import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'get'
  })
}

export function isShowPhrase() {
  return request({
    url: '/user/isShowPhrase',
    method: 'get'
  })
}

export function getLoginScanUrl(data) {
  return request({
    url: '/user/getLoginScanUrl',
    method: 'post',
    data
  })
}

export function checkScanLogin(data) {
  return request({
    url: '/user/checkScanLogin',
    method: 'post',
    data
  })
}

export function loginByScan(data) {
  return request({
    url: '/user/loginByScan',
    method: 'post',
    data
  })
}

export function closeScanQrCode(data) {
  return request({
    url: '/user/closeScanQrCode',
    method: 'post',
    data
  })
}

export function editInfo(data) {
  return request({
    url: '/user/editInfo',
    method: 'post',
    data
  })
}

export function changePassword(oldPwd, newPwd) {
  return request({
    url: '/user/changePassword',
    method: 'post',
    data: {
      oldPwd,
      newPwd
    }
  })
}

export function loginUser(id) {
  return request({
    url: '/user/loginUser',
    method: 'post',
    data: {
      id
    }
  })
}

// 获取验证码（有token）
export function sendCode(data) {
  return request({
    url: '/user/sendCode',
    method: 'post',
    data
  })
}

// 获取验证码（无token）手机
export function sendBindMobileCode(data) {
  return request({
    url: '/user/sendBindMobileCode',
    method: 'post',
    data
  })
}
// 获取验证码（无token）IP
export function sendCheckIPCode(data) {
  return request({
    url: '/user/sendCheckIPCode',
    method: 'post',
    data
  })
}
// 校验绑定手机号码
export function editMobile(data) {
  return request({
    url: '/user/loginBindMobile',
    method: 'post',
    data
  })
}
// 校验绑定手机号码(IP白名单)
export function checkIP(data) {
  return request({
    url: '/user/loginNotInWhiteList',
    method: 'post',
    data
  })
}
// 校验绑定手机号码(个人中心)
export function checkCode(data) {
  return request({
    url: '/user/checkCode',
    method: 'post',
    data
  })
}

// 修改绑定手机号码(个人中心)
export function editBindMobile(data) {
  return request({
    url: '/user/editBindMobile',
    method: 'post',
    data
  })
}

// 获取微信绑定验证码
export function getBindingWechatUrl() {
  return request({
    url: '/user/getBindingWechatUrl',
    method: 'get'
  })
}

// 检查微信是否已经绑定
export function checkBindingWechat() {
  return request({
    url: '/user/checkBindingWechat',
    method: 'get'
  })
}

// 解绑微信
export function deleteOpenID(params) {
  return request({
    url: '/user/deleteOpenID?' + params,
    method: 'get'
  })
}

// 设置微信日报推送维度
export function changeDailyReportDim(data) {
  return request({
    url: '/user/changeDailyReportDim',
    method: 'post',
    data
  })
}

export function getList() {
  return request({
    url: '/user/getUserList',
    method: 'get'
  })
}

export function loginPasswordExpire(data) {
  return request({
    url: '/user/loginPasswordExpire',
    method: 'post',
    data
  })
}
// 发送验证码（重新登录）
export function sendKeepLoginCode(data) {
  return request({
    url: '/user/sendKeepLoginCode',
    method: 'post',
    data
  })
}
// 重新登录
export function loginByKeep(data) {
  return request({
    url: '/user/loginByKeep',
    method: 'post',
    data
  })
}

export function getExpireUserList(data) {
  return request({
    url: '/user/getExpireUserList',
    method: 'post',
    data
  })
}

export function addExpireUser(data) {
  return request({
    url: '/user/addExpireUser',
    method: 'post',
    data
  })
}

export function deleteExpireUser(data) {
  return request({
    url: '/user/deleteExpireUser',
    method: 'post',
    data
  })
}

export function editExpireUser(data) {
  return request({
    url: '/user/changeExpireUser',
    method: 'post',
    data
  })
}

export function changeMergeDimension(data) {
  return request({
    url: '/user/changeMergeDimension',
    method: 'post',
    data
  })
}

export function changeDimensionType(data) {
  return request({
    url: '/user/changeDimensionType',
    method: 'post',
    data
  })
}

export function setTencentToken(data) {
  return request({
    url: '/user/setTencentToken',
    method: 'post',
    data
  })
}

export function getTencentTokenInfo() {
  return request({
    url: '/user/getTencentTokenInfo',
    method: 'get'
  })
}

// 生成当前登录用户的 skills token
export function generateAgentToken(data = {}) {
  return request({
    url: '/user/generateAgentToken',
    method: 'post',
    data
  })
}

export function getFeiShuLoginParam(data) {
  return request({
    url: '/user/getFeiShuLoginParam',
    method: 'post',
    data
  })
}

export function loginByFeishuCallback(data) {
  return request({
    url: '/user/loginByFeishuCallback',
    method: 'post',
    data
  })
}
